<div class="app-select">
  <div class="container">

    <div class="row">
      <div class="col-12 text-center">
        <div class="login-header text-center">
          <img src="/assets/img/dx-kulture-logo.svg" alt="DX Kulture" width="200"/>
        </div>
      </div>
    </div>
    <div class="row justify-content-center" [hidden]="loading">

      <div class="col-12 mb-5 col-md-6 col-lg-5"
        [hidden]="!principal.user?.roles.includes([userRoles.ADMIN, userRoles.CONTENT_OWNER, userRoles.SALES_REPRESENTATIVE]) && principal.user?.roles.includes(userRoles.READ_ONLY_ADMIN)">
        <div class="app-select-group">
          <h3 class="app-select-group-title">Main Dashboard</h3>
          @if (principal.user?.roles.includes(userRoles.ADMIN) || principal.user?.roles.includes(userRoles.SALES_REPRESENTATIVE) || principal.user?.roles.includes(userRoles.READ_ONLY_ADMIN)) {
            <mat-card appearance="outlined" class="mb-3">
              <mat-card-header (click)="mainDashboard()">
                <div mat-card-avatar class="">
                  <i class="fal fa-user-tie"></i>
                </div>
                <mat-card-title class="text-uppercase">Main dashboard</mat-card-title>
                <div class="mat-card-header-action">
                  <i class="fas fa-chevron-right" aria-hidden="true"></i>
                </div>
              </mat-card-header>
            </mat-card>
          }
          @if (principal.user?.roles.includes(userRoles.CAMPAIGN_MANAGER)) {
            <mat-card appearance="outlined" class="mb-3">
              <mat-card-header (click)="campaignsDashboard()">
                <div mat-card-avatar class="">
                  <i class="fal fa-user-tie"></i>
                </div>
                <mat-card-title class="text-uppercase">Campaigns dashboard</mat-card-title>
                <div class="mat-card-header-action">
                  <i class="fas fa-chevron-right" aria-hidden="true"></i>
                </div>
              </mat-card-header>
            </mat-card>
          }
          @if (principal.user?.roles.includes(userRoles.REV_OPS)) {
            <mat-card appearance="outlined" class="mb-3">
              <mat-card-header (click)="forecastDashboard()">
                <div mat-card-avatar class="">
                  <i class="fal fa-user-tie"></i>
                </div>
                <mat-card-title class="text-uppercase">Forecast dashboard</mat-card-title>
                <div class="mat-card-header-action">
                  <i class="fas fa-chevron-right" aria-hidden="true"></i>
                </div>
              </mat-card-header>
            </mat-card>
          }
          @if (principal.user?.roles.includes(userRoles.DESIGNER)) {
            <mat-card appearance="outlined" class="mb-3">
              <mat-card-header (click)="designerDashboard()">
                <div mat-card-avatar class="">
                  <i class="fal fa-user-tie"></i>
                </div>
                <mat-card-title class="text-uppercase">Designer dashboard</mat-card-title>
                <div class="mat-card-header-action">
                  <i class="fas fa-chevron-right" aria-hidden="true"></i>
                </div>
              </mat-card-header>
            </mat-card>
          }
          @if (principal.user?.roles.includes(userRoles.ADVERTISER)) {
            <mat-card appearance="outlined" class="mb-3">
              <mat-card-header (click)="advertiserDashboard()">
                <div mat-card-avatar class="">
                  <i class="fal fa-user-tie"></i>
                </div>
                <mat-card-title class="text-uppercase">Advertiser dashboard</mat-card-title>
                <div class="mat-card-header-action">
                  <i class="fas fa-chevron-right" aria-hidden="true"></i>
                </div>
              </mat-card-header>
            </mat-card>
          }
          @if (principal.user?.roles.includes(userRoles.FINANCE) && !principal.user?.roles.includes(userRoles.ADVERTISER)) {
            <mat-card appearance="outlined" class="mb-3">
              <mat-card-header (click)="financeDashboard()">
                <div mat-card-avatar class="">
                  <i class="fal fa-user-tie"></i>
                </div>
                <mat-card-title class="text-uppercase">Finance dashboard</mat-card-title>
                <div class="mat-card-header-action">
                  <i class="fas fa-chevron-right" aria-hidden="true"></i>
                </div>
              </mat-card-header>
            </mat-card>
          }
        </div>

        @if (principal.user?.roles.includes('CONTENT_OWNER')) {
          <div class="app-select-group" [ngClass]="{'mt-5': principal.user?.roles.includes('ADMIN')}">
            <h3 class="app-select-group-title">Content Owner Dashboard</h3>
            @if (coLoading) {
              <div class="data-loader">
                <mat-spinner [color]="'primary'"
                  [mode]="'indeterminate'"
                  [diameter]="30">
                </mat-spinner>
              </div>
            }
            @if (contentOwners?.length && !coLoading) {
              <div>
                @for (co of contentOwners; track co) {
                  <mat-card appearance="outlined" class="mb-3">
                    <mat-card-header (click)="coDashboard(co.id)">
                      <div mat-card-avatar class="">
                        <i class="fal fa-user-tie"></i>
                      </div>
                      <mat-card-title class="text-uppercase">{{co.name}}</mat-card-title>
                      <div class="mat-card-header-action">
                        <i class="fas fa-chevron-right" aria-hidden="true"></i>
                      </div>
                    </mat-card-header>
                  </mat-card>
                }
              </div>
            }
          </div>
        }
      </div>

      <div class="col-12 mb-5 col-md-6 col-lg-5"
        [hidden]="!principal.user?.publisherIds || !principal.user?.publisherIds.length">
        @if (pubLoading) {
          <div class="data-loader">
            <mat-spinner [color]="'primary'"
              [mode]="'indeterminate'"
              [diameter]="30">
            </mat-spinner>
          </div>
        }
        @if (!pubLoading) {
          <div class="app-select-group">
            <h3 class="app-select-group-title">Publisher Dashboards</h3>
            @if (publishers?.length) {
              <div>
                @for (p of publishers; track p) {
                  <mat-card appearance="outlined" class="mb-3">
                    <mat-card-header (click)="selectPublisher(p.id)">
                      <div mat-card-avatar class="">
                        <i class="fal fa-user"></i>
                      </div>
                      <mat-card-title class="text-uppercase">{{p.name}}</mat-card-title>
                      <div class="mat-card-header-action">
                        <i class="fas fa-chevron-right" aria-hidden="true"></i>
                      </div>
                    </mat-card-header>
                  </mat-card>
                }
              </div>
            }
          </div>
        }
      </div>
    </div>
  </div>
</div>
